// FLOW[49455]: one fail-closed role source for market-critical V2 direct URLs.
import type { ReactNode } from 'react';

import { ProtectedRoute } from '@/routes/ProtectedRoute';
import type { UserRole } from '@/types';

export const V2_ROOT_ROUTE_ROLES = [
  'sales_manager',
  'sales_head',
  'production',
  'accountant',
  'executive',
  'admin',
  'partner',
] as const satisfies readonly UserRole[];


export const V2_CRITICAL_ROUTE_ROLES = {
  sales: ['admin', 'sales_manager', 'executive'],
  companyOrders: ['admin', 'sales_manager', 'production', 'accountant', 'executive'],
  partnerSheet: ['admin', 'partner'],
  production: ['admin', 'production', 'executive'],
  prepress: ['admin', 'sales_manager', 'production', 'executive'],
  prepressQueue: ['admin', 'production', 'executive'],
  stock: ['admin', 'sales_manager', 'production', 'accountant', 'executive'],
  financeRead: ['admin', 'accountant', 'executive'],
  financeWrite: ['admin', 'accountant'],
  financePartnerBatches: ['admin', 'accountant', 'executive', 'production'],
  executive: ['admin', 'executive'],
  crmSupervisor: ['admin', 'executive', 'sales_head'],
} as const satisfies Record<string, readonly UserRole[]>;

export type V2CriticalRoutePolicy = keyof typeof V2_CRITICAL_ROUTE_ROLES;

interface V2CriticalRoleRouteProps {
  policy: V2CriticalRoutePolicy;
  children: ReactNode;
}

export function V2CriticalRoleRoute({
  policy,
  children,
}: V2CriticalRoleRouteProps) {
  return (
    <ProtectedRoute allowedRoles={[...V2_CRITICAL_ROUTE_ROLES[policy]]}>
      {children}
    </ProtectedRoute>
  );
}
